export const formPlvacyPolicy = () => {
  $(function () {
    const addContent =
      'プライバシーポリシーを確認し、<br class="u-sp-only" />同意します。';
    $(".js-privacypolicy .wpcf7-list-item-label").html(addContent);
  });
};
